<template>
    <div class="mainDiv">

    <el-form  ref="queryCondition" :model="queryCondition">
      <el-row >
        <el-col :span="5">
          分享人
          <el-select size="mini" v-model="queryCondition.userId" clearable placeholder="请选择" class="dialogDataWidth"  style="width: 60%;">
              <el-option v-for="item in userSelectedIdList" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
        </el-col>
        <el-col :span="5">
          状态
          <el-select size="mini" v-model="queryCondition.state" clearable placeholder="请选择" class="dialogDataWidth"  style="width: 60%;">
              <el-option v-for="item in state_option" :key="item.code" :label="item.value" :value="item.code">
              </el-option>
            </el-select>
        </el-col>
        
        <el-col :span="4" >
          <el-button type="primary" size="mini" @click='query(1)' icon="el-icon-search">查询</el-button>
          <el-button type="primary" plain size="mini" @click="reset" icon="el-icon-refresh">重置</el-button>
        </el-col>
      </el-row>

    </el-form>

    <el-table class="el-table" stripe size="mini" :data="pagedata.content" align="center" style="margin-top: 10px;" header-row-class-name="tableHeader">
      <el-table-column align='center' prop="id" type="index" label="序号"  label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="orderSn" label="订单号" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="createTime" label="出票时间" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="shareName" label="分享人" label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="amount" label="票价(元)"  label-class-name="greenLabel"></el-table-column>
      <el-table-column align='center' prop="shareState" label="状态" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-tooltip content="完成结算" v-if="scope.row.shareState == 2" placement="top" effect="light">
            <el-button @click="done(scope.row.id)" icon="el-icon-refresh" size="small"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

      <el-pagination
        :page-size="pagedata.size"
        layout="total, prev, pager, next, jumper"
        :total="pagedata.totalElements"
        :current-page.sync="pagedata.number"
        @current-change="query" class="mb">
      </el-pagination>

    </div>
</template>
<script>

  export default {
    name: 'chaekList',
    mounted: function () {
      this.selectUser();
      this.type_option = this.CommonUtil.getCodeList('ticket_type');
      this.queryCondition.createDate = [this.DateUtil.getCurrentDate(), this.DateUtil.getCurrentDate()];
      this.query();
    },
    data() {
      return {
        msg: 'this is role',
        countCreateMoney: 0,
        countCreateNum: 0,
        countPersonNum: 0,
        userSelectedIdList: [],
        queryCondition: {
          userId: '',
          state: ''
        },
        pagedata: {
          content: [],
          totalElements: 0,
          totalPages: 1,
          size: 10,
          number: 1,
        },
        state_option: [{code: 1,value: "待确认"},{code: 2,value: "待结算"},{code: 3,value: "已结算"}],
      }
    },
    methods: {
      //状态改成汉字
      formatStr(row, column) {
        if(row.shareState == 1){
          return "待确认";
        }else if(row.shareState == 2){
          return "待结算";
        }else{
          return "已结算";
        }
      },
      done: function(id){
        this.$confirm('确定是否已与民宿结算完成?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/order/doneShare/' + id).then(response => {
            this.query();
            this.$message({
              type: 'success',
              message: '成功!'
            });
          });
        })
      },
      // 查询按钮
      query: function (currentPage) {
        if(!isNaN(currentPage) && currentPage > 0){
          this.pagedata.number = currentPage;
        }

        var url = '/order/shareList';
        url += '?userId=' + this.queryCondition.userId;
        url += '&state=' + this.queryCondition.state;
        url += '&pageNumber=' + this.pagedata.number  + '&pageSize=' + this.pagedata.size;
        this.$axios.get(url).then(response => {
          this.pagedata = response.data
        })
      },
      reset: function () {
        this.queryCondition.userId = '';
        this.queryCondition.state = '';
        this.$refs.queryCondition.resetFields();
        this.query(1);
      },
      
      /**
       * 给角色选人
       */
      selectUser(){
        this.$axios.get('/user/getUserListByRole/7').then(response => {
          this.userSelectedIdList = response.data;
        })
      },
      
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/chart/share.vue